import { makeAutoObservable, runInAction } from 'mobx';
import router from 'next/router';
import { ISiteTypesData, ISiteTypesDataLanguage, TLocale } from '@typescript/index';
import nextSiteTypesApi from '@features/api/nextApiService/nextSiteTypesApi';
import getOffer from '@utils/getOffer';
import { SITE_TYPE_KEY, DEFAULT_LOCALE } from '@const/index';
// TODO: add a mechanism to identify the region and language based on the website address

/** Maps LangPopup codes like `en-EN` / `pl_PL` to i18n locale (`en`, `pl`). */
export const toI18nLocale = (langCode: string): TLocale => langCode.split(/[-_]/)[0].toLowerCase() as TLocale;
class SIteTypesStore {
  public siteTypes: Array<ISiteTypesData> | null = null;
  public selectedLanguage: ISiteTypesDataLanguage | null | undefined = null;
  public selectedSiteType: ISiteTypesData | null = null;
  public currentLocale: TLocale | null = null;
  public currentOffer: string | null = null;
  public isSideBarOpen = false;

  /** When set, LanguageSideBar UI (and site-types fetch) uses this locale instead of page locale. */
  public sideBarUiLocale: TLocale | null = null;
  constructor() {
    makeAutoObservable(this);
  }
  public initializeData = async () => {
    const {
      locale
    } = router;
    const [offerName] = getOffer();
    if (!locale) return;
    this.currentLocale = locale as TLocale;
    this.currentOffer = offerName;
    await this.fetchSiteTypesData(locale as TLocale);
    this.setSelectedSiteType();
  };
  public setExternalLanguage = async (currentLocale: TLocale) => {
    this.currentLocale = currentLocale;
    await this.fetchSiteTypesData(currentLocale);
    this.setSelectedSiteType();
  };
  private fetchSiteTypesData = async (locale: TLocale) => {
    if (!locale) return;
    const siteTypes = await nextSiteTypesApi.getSiteTypes(locale);
    runInAction(() => {
      this.siteTypes = siteTypes;
    });
  };
  private setSelectedSiteType = () => {
    if (!this.siteTypes || !Array.isArray(this.siteTypes)) return;
    this.selectedSiteType = this.siteTypes.find(st => st.key === SITE_TYPE_KEY) || null;
  };
  public setDefultLanguage = (locale = DEFAULT_LOCALE): ISiteTypesDataLanguage | null => {
    if (!this.selectedSiteType || !Array.isArray(this.selectedSiteType.languages)) return null;
    this.selectedLanguage = this.selectedSiteType.languages.find(l => l.code === locale);
    return this.selectedLanguage || null;
  };
  public getSiteTypesByTypes = (types: string[]): ISiteTypesData[] => {
    if (!this.siteTypes || !Array.isArray(this.siteTypes)) return [];
    return this.siteTypes.filter(st => types.includes(st.siteType));
  };
  public openSidebar = (langPopupCode?: string | null) => {
    const uiLocale = langPopupCode ? toI18nLocale(langPopupCode) : null;
    this.sideBarUiLocale = uiLocale;
    this.isSideBarOpen = true;
    if (uiLocale) {
      void this.fetchSiteTypesData(uiLocale);
    }
  };
  public closeSidebar = () => {
    const hadUiLocale = !!this.sideBarUiLocale;
    this.isSideBarOpen = false;
    this.sideBarUiLocale = null;
    if (hadUiLocale && router.locale) {
      void this.fetchSiteTypesData(router.locale as TLocale);
    }
  };
}
export default SIteTypesStore;